// Who gets the student phone shell (components/StudentMobile).
import { isDesktopApp } from './desktopApp';

const PHONE_MAX_WIDTH = 768;

/**
 * A real phone, in either orientation: a touch screen with no hover whose short
 * side is under the tablet breakpoint. Screen size, not window size, so turning
 * the phone sideways to watch a video changes nothing.
 *
 * Quizzes and the code editor are refused on this test alone, never on a narrow
 * window: a laptop in half a screen can sit an exam, and resizing one mid-exam
 * must not take the exam away.
 */
export const isPhoneDevice = () => {
  if (typeof window === 'undefined' || isDesktopApp()) return false;
  const touchOnly = window.matchMedia?.('(pointer: coarse) and (hover: none)')?.matches;
  const shortSide = Math.min(window.screen?.width || 0, window.screen?.height || 0);
  return !!touchOnly && shortSide > 0 && shortSide < PHONE_MAX_WIDTH;
};

let opensShell = null;

/**
 * Decided once per page load and kept. Resizing a laptop window across 768px
 * must not swap the page under someone who is typing or watching; it picks up
 * the other layout on the next load.
 */
export const opensPhoneShell = () => {
  if (opensShell === null) {
    opensShell = typeof window !== 'undefined'
      && !isDesktopApp()
      && (window.innerWidth < PHONE_MAX_WIDTH || isPhoneDevice());
  }
  return opensShell;
};
